type ModuleNotEnabledStateProps = {
  title?: string;
  description?: string;
  ctaLabel?: string;
  ctaHref?: string;
};

const ModuleNotEnabledState = ({
  title = 'Module not enabled',
  description = 'This module is not included in your current plan. Upgrade to unlock this feature.',
  ctaLabel = 'Upgrade plan',
  ctaHref = '/store/upgrade'
}: ModuleNotEnabledStateProps) => (
  <section className="coming-soon-wrap" aria-live="polite">
    <p className="coming-soon-eyebrow">Plan required</p>
    <h1 className="coming-soon-title">{title}</h1>
    <p className="coming-soon-copy">{description}</p>
    <div style={{ marginTop: 16 }}>
      <a className="btn primary" href={ctaHref}>
        {ctaLabel}
      </a>
    </div>
  </section>
);

export default ModuleNotEnabledState;

